const enum InitiateReleaseError {
  WRONG_BANK_ACCOUNT_NUMBER = 
  'Unable to initiate release of the tenancy deposit as the landlord is ' +
  'not the owner of the specified bank account',
};

export {
  InitiateReleaseError,
};
